import DropdownCommon, {
  DropdownItemStyled,
} from 'components/common/DropdownCommon';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import React, { useState } from 'react';
import styled from 'styled-components';

const SEARCH_BY_REFERENCE = {
  refNumber: 'Reference',
  receiverName: 'Receiver',
};

const SEARCH_BY_LABEL_TRANSLATE = {
  refNumber: 'label_ref_number',
  receiverName: 'label_receiver',
};

const CustomSearchDropdown = ({
  searchBy,
  setSearchBy,
  setSearchValue,
  setSearched,
}) => {
  const { t } = useLang();

  const [isShowDropdown, setShowDropdown] = useState(false);

  const handleChangeSearchBy = (keySearch) => {
    setSearchValue('');

    setSearched(false);

    setSearchBy(keySearch);

    setShowDropdown(false);
  };

  const handleDropdownOnToggle = () => {
    setShowDropdown(!isShowDropdown);
  };

  const renderDropdownMenuChildren = () => (
    <>
      {Object.keys(SEARCH_BY_REFERENCE).map((key, index) => (
        <DropdownItemStyled
          key={index}
          eventKey={index}
          onClick={() => handleChangeSearchBy(key)}
          style={{
            borderRadius: '8px',
          }}
        >
          {t(SEARCH_BY_LABEL_TRANSLATE[key])}
        </DropdownItemStyled>
      ))}
    </>
  );

  const getStyleDropdown = () => ({
    width: '120px',
    height: '44px',
    border: 'none',
  });
  const getStyleDropdownToggle = () => ({
    minHeight: '28px',
    textTransform: 'initial',
    padding: 0,
    paddingRight: '32px',
    borderRight: '1px solid var(--ds-c-grey-light)!important',
    borderRadius: 0,
  });
  const getStyleDropdownMenu = () => ({
    borderRadius: '8px',
    background: '#fff',
    minWidth: '128px',
    transform: 'translate(-8px, 45px)',
  });

  return (
    <SearchDropdownStyled>
      <DropdownCommon
        value={t(SEARCH_BY_LABEL_TRANSLATE[searchBy])}
        isShowDropdown={isShowDropdown}
        onToggle={handleDropdownOnToggle}
        renderDropdownMenuChildren={renderDropdownMenuChildren}
        styleDropdown={getStyleDropdown()}
        styleDropdownToggle={getStyleDropdownToggle()}
        styleDropdownMenu={getStyleDropdownMenu()}
      />
    </SearchDropdownStyled>
  );
};

const SearchDropdownStyled = styled.div`
  position: absolute;
  left: 10px;
  display: flex;
  align-items: center;
  ${Fade};
  & .dropdown {
    padding: 10px 0px;
  }
`;

export default CustomSearchDropdown;
